export { default as registerCoreBlocks } from './register-blocks';
